import { createContext, useContext } from 'react';
import { BRAND, BrandConfig } from '../config/branding';

const BrandingContext = createContext<BrandConfig>(BRAND);

export const BrandingProvider = BrandingContext.Provider;

export const useBranding = () => useContext(BrandingContext);

